module.exports = __webpack_public_path__ + "static/img/02002A_4_5_6_R_20200611_LC.2bea9a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02002A_4_5_6_R_20200611_LC.png
// module id = YgLU
// module chunks = 0